// this is to create project token map for smooth flow in  time line scheduler
export default {
  namespaced: true,
  state: {
    filters: {}
  },
  getters: {
    getFilters: state => state.filters
  },
  mutations: {
    updateFilters (state, filters) {
      state.filters = filters
    }
  }
}
